addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.accordion-header').forEach(button => {
    button.addEventListener('click', () => {
      const content = button.nextElementSibling;
      button.parentElement.classList.toggle('active-parts')
      content.classList.toggle('active-parts');
    });
  });
  document.querySelectorAll('.decrease-qty').forEach(button => {
    button.addEventListener('click', () => changeQuantity(-1, button.dataset.variantId))
  });
  document.querySelectorAll('.increase-qty').forEach(button => {
    button.addEventListener('click', () => changeQuantity(1, button.dataset.variantId))
  });
  document.querySelectorAll('.part-atc').forEach(button => {
    button.addEventListener('click', () => addPartToCart(button, button.dataset.variantId))
  });
  document.querySelectorAll('.qty-input').forEach(input => {
    input.addEventListener('change', () => changeQuantity(input.value, input.dataset.variantId))
  });
  initHotspots()
  document.addEventListener('click', function(e) {
    const popup = document.getElementById('partPopup');
    if (!popup.contains(e.target) && !e.target.closest('.hotspot')) {
        popup.classList.remove('visible');
    }
  });
  window.addEventListener('scroll', function() {
    const popup = document.getElementById('partPopup');
    popup.classList.remove('visible');
  });

  // Handle hash changes (when user clicks anchor links)
  window.addEventListener('hashchange', (e) => {
    e.preventDefault();
    handleHashNavigation(e);
  });
  
  window.addEventListener('load', () => {
    if (window.location.hash) {
      setTimeout(() => {
        handleHashNavigation();
      }, 100);
    }
  });
  
  // Add this new one to prevent default anchor link behavior:
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (link && link.getAttribute('href') !== '#') {
      e.preventDefault();
      window.location.hash = link.getAttribute('href');
    }
  });
})

function initHotspots() {
  const hotspots = document.querySelectorAll('.hotspot');
  const popup = document.getElementById('partPopup');
  hotspots.forEach(hotspot => {
    const sectionHandle = hotspot.dataset.sectionHandle;
    hotspot.addEventListener('click', (e) => {
      e.stopPropagation();
      displayPopup(popup, hotspot, sectionHandle);
    });
    hotspot.addEventListener('mouseenter', (e) => { 
      displayPopup(popup, hotspot, sectionHandle);
    });
  });
  popup.addEventListener('mouseleave', function(e) {
    popup.classList.remove('visible');
  });
}

function displayPopup(popup, hotspot, sectionHandle) {
  popup.querySelector('.part-number').textContent = hotspot.dataset.sectionNumber;
  popup.querySelector('.part-name').textContent = hotspot.dataset.sectionName
  popup.querySelector('.part-quantity').textContent = `(${ hotspot.dataset.sectionQty }x)`;

  popup.querySelector('.view-parts-btn').addEventListener('click', (e) => {
    e.stopPropagation();
    
    // Remove old click handler to avoid duplicates
    const existingHandler = popup.querySelector('.view-parts-btn').onclick;
    if (existingHandler) {
      popup.querySelector('.view-parts-btn').removeEventListener('click', existingHandler);
    }
    
    // Set the hash in URL (this will trigger our new handler)
    window.location.hash = sectionHandle;
    
    popup.classList.remove('visible');
    popup.dispatchEvent(new Event('mouseleave'));
  });
    
  // Position popup off-screen first to measure it
  popup.style.left = '-9999px';
  popup.classList.add('visible');
  
  // Get dimensions after visible
  const rect = hotspot.getBoundingClientRect();
  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;
  
  // Get parent container bounds
  const parentContainer = document.getElementById('diagram-parent');
  const parentRect = parentContainer.getBoundingClientRect();
  
  let leftPos = rect.left - 2;
  let topPos = rect.top - 2;
  
  // Calculate how far beyond parent's right edge it would go
  const overflow = (leftPos + popupWidth) - (parentRect.right);
  
  // Only shift left if it would go beyond parent bounds
  if (overflow > 0) {
      leftPos = leftPos - overflow - 10;
  }
  
  // Ensure it doesn't go beyond parent's left edge
  if (leftPos < parentRect.left) {
      leftPos = parentRect.left + 10;
  }
  
  // Keep within parent's top/bottom bounds
  if (topPos < parentRect.top) {
      topPos = parentRect.top + 10;
  }
  
  if (topPos + popupHeight > parentRect.bottom) {
      topPos = parentRect.bottom - popupHeight - 10;
  }
  
  popup.style.left = leftPos + 'px';
  popup.style.top = topPos + 'px';
}

function goToPartsGroup (groupName) {
  document.querySelectorAll('.accordion-header').forEach(button => {
    if (button.nextElementSibling.classList.contains('active-parts')) {
      const contentTransition = button.nextElementSibling.style.transition;
      const parentTransition = button.parentElement.style.transition;
      button.nextElementSibling.style.transition = 'none';
      button.parentElement.style.transition = 'none'
      button.click()
      button.nextElementSibling.style.transition = contentTransition;
      button.parentElement.style.transition = parentTransition;
    }
  });
  if (!document.getElementById(groupName).lastElementChild.classList.contains('active-parts')) {
      document.getElementById(groupName).firstElementChild.click();
  }
}

function handleHashNavigation(event) {
  const hash = window.location.hash;
  if (!hash) return;
  
  // Prevent default browser anchor scrolling behavior
  if (event && event.preventDefault) {
    event.preventDefault();
  }
  
  const targetElement = document.querySelector(hash);
  if (!targetElement) return;
  
  const accordionItem = targetElement.closest('.accordion-item');
  
  if (accordionItem) {
    const accordionContent = accordionItem.querySelector('.accordion-content');
    const accordionHeader = accordionItem.querySelector('.accordion-header');
    
    // IMMEDIATELY scroll to approximate position to prevent browser scrolling
    const currentRect = targetElement.getBoundingClientRect();
    const currentScrollTop = window.pageYOffset + currentRect.top - 100;
    
    window.scrollTo({
      top: currentScrollTop,
      behavior: 'auto' // No smooth scrolling initially
    });
    
    // Close all other accordions
    document.querySelectorAll('.accordion-item').forEach(item => {
      if (item !== accordionItem && item.classList.contains('active-parts')) {
        const content = item.querySelector('.accordion-content');
        content.style.transition = 'none';
        item.style.transition = 'none';
        item.classList.remove('active-parts');
        content.classList.remove('active-parts');
        setTimeout(() => {
          content.style.transition = '';
          item.style.transition = '';
        }, 10);
      }
    });
    
    // Open target accordion
    if (!accordionContent.classList.contains('active-parts')) {
      accordionHeader.click();
    }
    
    // Final smooth scroll adjustment after animation
    setTimeout(() => {
      const finalRect = targetElement.getBoundingClientRect();
      const finalScrollTop = window.pageYOffset + finalRect.top - 100;
      
      if (Math.abs(finalScrollTop - window.pageYOffset) > 5) {
        window.scrollTo({
          top: finalScrollTop,
          behavior: 'smooth'
        });
      }
    }, 550);
  }
}

function changeQuantity(amount, variantId) {
  let currentQty = parseInt(document.getElementById(variantId + "-qty").value)
  if (currentQty == 1 && amount == -1) currentQty = 2
  document.getElementById(variantId + "-qty").value = currentQty + amount
  document.getElementById(variantId + "-qty-mobile").value = currentQty + amount
  document.getElementById(variantId + "-atc").lastElementChild.innerHTML = 'Add To Cart';
}

async function addPartToCart(button, variantId) {
  const qtyToAdd = parseInt(document.getElementById(variantId + "-qty").value)
  button.disabled = true
  button.lastElementChild.innerHTML = `Adding...`;
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: qtyToAdd,
      properties: {
        "partsPageURL": window.location.href
      }
    })
  });
  
  if (response.ok) {
    const item = await response.json();
    console.log('Added to cart:', item);
    button.disabled = false
    button.lastElementChild.innerHTML = `${qtyToAdd} Added`
    document.querySelector('.cart-button').click();
    updateCartBubble();
  } else {
    console.error('Failed to add to cart');
    button.lastElementChild.innerHTML = 'Error adding to cart, please contact us.'
  }
}